import { AbstractControl } from '@angular/forms';
import { IonContent,  NavParams, Platform } from '@ionic/angular';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CurrencyFormatterPipe } from 'src/app/pipes/currency-formatter/currency-formatter.pipe';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BalanceModel } from 'src/app/models/balance-model';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format.pipe';
import { LimitsService } from 'src/app/services/limits/limits.service';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';

@Component({
  selector: 'app-set-loss-limits',
  templateUrl: './set-loss-limits.component.html',
  styleUrls: ['./set-loss-limits.component.scss'],
})

export class SetLossLimitsComponent implements OnInit, AfterViewInit {
    @Input() previousPage: string = "";
    @ViewChild('scrollableContent', {  }) scrollableContent: ElementRef;
    private scrollContainer: any;

    ngAfterViewInit() {
        this.siteContentService.loadConfig('loss_limit')
            .then((response: SiteContentInterface) => {
            this.labels = response
            })
        if(this.scrollContainer){
            this.scrollContainer = this.scrollableContent.nativeElement;
        }
    }

    @ViewChild('Content', {read: IonContent, static: false}) content: IonContent;
    public error = null;

    public lossLimitsForm: FormGroup;

    public loss_daily_limit: AbstractControl;
    public loss_weekly_limit: AbstractControl;
    public loss_monthly_limit: AbstractControl;

    public dailyLossLimits: any;
    public weeklyLossLimits: any;
    public monthlyLossLimits: any;

    public globalDailyLimit: any;
    public globalWeeklyLimit: any;
    public globalMonthlyLimit: any;
    public globalLimits: any[] = [];

    public lossLimits: any[] = [];

    public confirm:boolean = false;
    public successScreen:boolean = true;

    public deletePrompt:boolean = false;
    public deletePromptScreen:boolean = true;
    public deleteTerm:string;

    public rejectPrompt:boolean = false;
    public rejectPromptScreen:boolean = true;

    public state: string;
    public title: string = 'Set Loss Limits'

    public currency: any;
    public dailyLimitError: boolean = false;
    public weeklyLimitError: boolean = false;
    public monthlyLimitError: boolean = false;
    public labels: SiteContentInterface;


    private floatingPointValidator = "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$";

    constructor(
        private siteContentService: SiteContentService,
        private responsibleGamingProvider: ResponsibleGamingService,
        public successMessageProvider: SuccessMessageService,
        public platform: Platform,
        public currencyFormatterPipe: CurrencyFormatterPipe,
        public accountBalanceService: AccountBalanceService,
        public dateFormatPipe: DateFormatPipe,
        private successMessageService:SuccessMessageService,
        public limitsService: LimitsService
    ) {
        this.labels = new SiteContentModel();
        this.successMessageProvider.clearMessage();
        this.error = null;

        this.getLossLimits();
    }

    ngOnInit() {

        this.lossLimitsForm = new FormGroup(
            {
                loss_daily_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)]),
                loss_weekly_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)]),
                loss_monthly_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)])
            },  this.atLeastOneFieldValidator
        );

        this.loss_daily_limit = this.lossLimitsForm.get('loss_daily_limit');
        this.loss_weekly_limit = this.lossLimitsForm.get('loss_weekly_limit');
        this.loss_monthly_limit = this.lossLimitsForm.get('loss_monthly_limit');

        this.getGlobalLimits();

        // we need to get currency
        this.accountBalanceService.getBalance().subscribe((response: BalanceModel) =>{
            this.currency = response.getDefaultCurrency();
        });
    }

    getGlobalLimits() {
        this.responsibleGamingProvider.getGlobalLimits().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.globalLimits = response.payload.filter((limit) => {
                        return limit.limitType == "LOSS";
                    });

                    this.globalLimits.forEach((limit) => {
                        if (limit.limitTermType == "DAILY") {
                            this.globalDailyLimit = limit.currentLimit;
                            this.loss_daily_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(limit.currentLimit)]);
                        }
                        else if (limit.limitTermType == "WEEKLY") {
                            this.globalWeeklyLimit = limit.currentLimit;
                            this.loss_weekly_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(limit.currentLimit)]);
                        }
                        else if (limit.limitTermType == "MONTHLY") {
                            this.globalMonthlyLimit = limit.currentLimit;
                            this.loss_monthly_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(limit.currentLimit)]);
                        }
                    });
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }


    ionViewDidEnter() {
        this.successMessageService.clearMessage();
    }

    getLossLimits() {
        let tempLimits: any[] = [];

        this.responsibleGamingProvider.getLossLimit().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    tempLimits = response.payload;
                    for (const index in tempLimits) {
                        this.lossLimits.push(tempLimits[index]);
                    }

                    this.updateLossLimits(this.lossLimits);
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    updateLossLimits(lossLimits: any[]) {
        this.loss_daily_limit.setValue("");
        this.loss_weekly_limit.setValue("");
        this.loss_monthly_limit.setValue("");

        this.loss_daily_limit.markAsPristine();
        this.loss_weekly_limit.markAsPristine();
        this.loss_monthly_limit.markAsPristine();


        for (const i in lossLimits) {
            if (lossLimits[i] != null) {
                if (lossLimits[i].currentLimitTermType == "DAILY") {
                    this.dailyLossLimits = lossLimits[i];
                }

                if (lossLimits[i].currentLimitTermType == "WEEKLY") {
                    this.weeklyLossLimits = lossLimits[i];
                }
                if (lossLimits[i].currentLimitTermType == "MONTHLY") {
                    this.monthlyLossLimits = lossLimits[i];
                }
            }
        }
    }

    deleteLimit(term) {
        this.successMessageProvider.clearMessage();
        this.error = null;

        this.deletePrompt = false;
        this.deletePromptScreen = false;

        const requestObj: any = {};
        requestObj.termType = term.toUpperCase();

        this.responsibleGamingProvider.deleteLossLimit(requestObj).subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.getLossLimits();
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    setLimits( ) {
        this.successMessageProvider.clearMessage();
        this.error = null;
        this.successScreen = false;
        this.confirm = false;

        this.responsibleGamingProvider.setLossLimit(this.lossLimitsForm.value).subscribe({
            next: (response: any) => {
                if (response && !!response.result ) {
                    this.getLossLimits();

                    this.successMessageProvider.setMessage('Your loss limits were set.');

                    this.content.scrollToTop();
                }
            },
            error: (error) => {

                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_TERM_TYPE':
                        error.setErrorMessage('Limit cannot be 0!');
                        break;
                    default:
                        error.setErrorMessage('');
                        break;
                }
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    onLimitChanged(term) {
        console.log('limitChanged');
        if(term.toUpperCase() == "DAILY") {
            this.dailyLimitChanged();
        } else if(term.toUpperCase() == "WEEKLY") {
            this.weeklyLimitChanged();
        } else if(term.toUpperCase() == "MONTHLY") {
            this.monthlyLimitChanged();
        }
    }

    dailyLimitChanged() {
        if (this.globalDailyLimit != null) {
            this.dailyLimitError = parseInt(this.loss_daily_limit.value) > parseInt(this.globalDailyLimit);
        }
    }

    weeklyLimitChanged() {
        if (this.globalWeeklyLimit != null) {
            this.weeklyLimitError = parseInt(this.loss_weekly_limit.value) > parseInt(this.globalWeeklyLimit);
        }
    }

    monthlyLimitChanged() {
        if (this.globalMonthlyLimit != null) {
            this.monthlyLimitError = parseInt(this.loss_monthly_limit.value) > parseInt(this.globalMonthlyLimit);
        }
    }

    atLeastOneFieldValidator(group: FormGroup): {[key: string]: any} {
        let isAtLeastOne = false;
        if (group && group.controls) {
            for (const control in group.controls) {
                if (Object.prototype.hasOwnProperty.call(group.controls, control) && group.controls[control].valid && group.controls[control].value) {
                    isAtLeastOne = true;
                    break;
                }
            }
        }
        return isAtLeastOne ? null : { 'required': true };
    }

    enterPressed() {
      if(!this.lossLimitsForm.invalid) {
        this.setLimits();
      }
    }

    onDeleteLimitClicked(term){
      this.deleteTerm = term;
      this.successMessageProvider.clearMessage();
      this.deleteLimit(this.deleteTerm);
    }

    onClose = () =>{
        this.limitsService.onCloseCommon(this.previousPage == "SignupResult");
    }
}


